<div fxLayout="row" fxLayoutAlign="space-between center" [ngClass]="{ odd: odd, even: even }" class="row">
    <div fxFlex="20" class="col" (click)="showDescription = !showDescription">{{ priceListCode.Code }}</div>
    <div fxFlex="20" class="col" (click)="showDescription = !showDescription">{{ priceListCode.Name }}</div>
    <div fxFlex="20" class="col" (click)="showDescription = !showDescription">{{ priceListCode.SubCodeCount }}</div>
    
    
    <div fxFlex="20" class="col" (click)="showDescription = !showDescription" *ngIf="!canChangePrice">{{ priceListCode.FinalPrice }}</div>
    <div fxFlex="20" class="col" (click)="showDescription = !showDescription" *ngIf="canChangePrice">
        <mat-form-field>
            <input type="number" matInput inputmode="numeric" min="0" max="999999" [(value)]="priceListCode.FinalPrice" (change)="onChangePrice($event)">
        </mat-form-field>
    </div>

    <div fxFlex="20" class="col"><button mat-raised-button color="primary"
            (click)="onSelect($event)">{{ 'TREATMENT.SELECT'| translate }}</button></div>
</div>
<div *ngIf="showDescription" fxLayout="row" fxLayoutAlign="space-between" [ngClass]="{ odd: odd, even: even }"
    class="row">
    <div fxFlex="20" fxLayoutAlign="start" class="col primary description">{{ 'TREATMENT.DESCRIPTION' | translate }}
    </div>
    <div fxFlex="80" fxLayoutAlign="start" class="col description">{{ priceListCode.Description }}</div>
</div>